<template>
  <div id="container" class="member_st">
    <!-- 개인정보수정 & sub menu -->
    <AccountHead current-tab="orders" />

    <!-- 최근 주문 내역 START -->
    <div class="section fill">
      <div class="inner">
        <div class="box_title">
          <h2>구매 내역</h2>
          <!-- <p class="guide_txt">{{ $t('views.member.orders.6183') }}</p> -->
        </div>

        <div v-if="getAccountOrders" class="mypage_detail">
          <!-- TODO: SHOULD BE A COMPONENT -->
          <div v-for="(order, idx) in getAccountOrders" :key="idx" class="box">
            <div class="order_title">
              <div>
                <dl>
                  <dt>{{ $t('views.member.orders.306') }}</dt>
                  <dd>
                    <span>{{ order.orderDtime | timestamp }}</span>
                  </dd>
                </dl>
                <dl>
                  <dt>
                    <!-- {{
                    order.purchaseTp === 'C'
                      ? ''
                      : $t('views.member.orders.5626')
                  }} -->
                    {{ $t('views.member.orders.5626') }}
                  </dt>
                  <dd>
                    <span class="num">
                      <!-- {{
                    order.purchaseTp === 'C' ? '쿠폰 적용' : order.orderCd
                  }} -->
                      {{ order.orderCd }}
                    </span>
                  </dd>
                </dl>
              </div>
              <!-- <router-link
                v-show="!order || order.purchaseTp !== 'C'" -->
              <router-link
                :to="{
                  name: 'order_detail',
                  params: { id: order.orderCd, order, currentTab: 'orders' }
                }"
                class="box_btn line"
              >
                <span class="an_t">
                  주문 상세보기
                </span>
              </router-link>
            </div>
            <ul class="order_book">
              <li
                v-for="(item, itemIdx) in order.orderGoodsList"
                :key="itemIdx"
              >
                <div class="cover_wrap">
                  <router-link
                    v-if="item.purchaseTp !== 'GFT'"
                    :to="{
                      name:
                        order.bookTp === 'EBOOK'
                          ? 'library_book_detail'
                          : 'book_detail',
                      params: { id: item.bookCd }
                    }"
                    class="thum_wrap"
                  >
                    <img :src="item.thumbUrl" :alt="item.bookNm" />
                  </router-link>
                  <a v-else class="thum_wrap">
                    <img :src="item.thumbUrl" :alt="item.bookNm" />
                  </a>
                </div>
                <div class="info_wrap">
                  <cite class="meta_title">{{ item.bookNm }}</cite>
                  <p>
                    <span class="meta_author">{{ item.author }}</span>
                    <span class="gap">/</span>
                    <span class="meta_publisher">{{ item.publisher }}</span>
                    <!-- <span class="gap">/</span>
                    <span class="meta_tel">{{ item.isbn }}</span> -->
                  </p>
                  <p>
                    <span class="meta_type">{{ item.bookTp }}</span>
                  </p>
                  <p>
                    <span class="meta_num">
                      총
                      <span class="num">{{ item.units }}</span>
                      권
                    </span>
                    <span
                      v-if="item.ebookOrders && item.ebookOrders.isPeriodic"
                    >
                      <!-- {{ item.ebookOrders.rightsFrom }} -->{{
                        item.ebookOrders.rightsTo
                          ? `~${item.ebookOrders.rightsTo}`
                          : '무제한'
                      }}
                    </span>
                    <del v-if="item.couponDiscount > 0" class="list_price">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        format-style="currency"
                        :currency="item.currencyTp"
                        :number="item.listPrice"
                      />
                    </del>
                    <span v-if="item.couponDiscount > 0" class="percent">
                      ({{
                        Math.round(
                          ((item.listPrice - item.saleAmt) / item.listPrice) *
                            100
                        )
                      }}%
                      <span class="arrow"></span>
                      )
                    </span>
                    <span
                      v-if="
                        (item.saleAmt && !item.ebookOrders) ||
                        (item.saleAmt && item.ebookOrders)
                      "
                    >
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="item.currencyTp"
                        :number="item.saleAmt"
                      />
                    </span>

                    <span v-if="!item.saleAmt && item.purchaseTp === 'PMT'">
                      <vue-intl-numberformat
                        locale="ko-KR"
                        class="price"
                        format-style="currency"
                        :currency="getCurrency.currency"
                        :number="0"
                      />
                    </span>
                  </p>
                </div>
                <div
                  v-show="
                    item.purchaseTp === 'PMT' ||
                    (isPc && item.idx === 1) ||
                    (!isPc && item.idx === order.orderGoodsList.length)
                  "
                  class="btn_wrap"
                >
                  <!-- <div v-show="item.menuShowYn === 'Y'" class="btn_wrap"> -->
                  <div class="cell">
                    <!-- 여기 -->
                    <p class="state_txt">
                      {{
                        item.ebookOrders && item.ebookOrders.ebookOptNm
                          ? item.ebookOrders.ebookOptNm
                          : item.purchaseTp === 'PRS'
                          ? '증정본'
                          : '선물'
                      }}
                    </p>
                    <!-- <router-link
                      v-if="!item.buyTp.ebook"
                      :to="{
                        name: 'order_tracking',
                        params: { order }
                      }"
                      class="box_btn dull"
                      :class="{ none: order.delivery.trackingYn === 'N' }"
                      ><span class="an_t">{{
                        $t('views.member.orders.9286')
                      }}</span></router-link
                    > -->
                  </div>

                  <!-- 교재 - BOOK(종이책) : 배송 준비중일 경우 이곳은 소 버튼 -->
                  <div
                    v-show="
                      ((isPc && item.idx === 1) ||
                        ((isTablet || isMobile) &&
                          item.idx === order.orderGoodsList.length)) &&
                      !(
                        order.orderGoodsList.length >= 2 &&
                        order.orderGoodsList.some(
                          (orderItem) => orderItem.cancelYn === 'N'
                        )
                      )
                    "
                    class="cell"
                  >
                    <a
                      class="box_btn max cancel_button"
                      :class="{
                        none:
                          item.cancelYn === 'N' ||
                          (item.ebookOrders &&
                            item.ebookOrders.purchaseTp !== 'PMT')
                      }"
                      @click="toggleCancelOrderModal(order)"
                    >
                      <span class="an_t">주문 취소</span>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <!-- PAGINATION START -->
          <Pagination
            :current-page="currentPage"
            :total-count="getAccountOrderTotalCount"
            :item-per-page="ordersPerPage"
            @paginate="paginate"
          />
          <!-- PAGINATION END -->
        </div>
        <EmptyData v-else data-tp="주문내역" />
      </div>
    </div>
    <!-- ****************** -->
    <!-- CANCEL ORDER MODAL -->
    <!-- ****************** -->
    <transition name="modal-fade">
      <Modal v-if="showCancelOrderModal" @close="toggleCancelOrderModal">
        <div class="ly_pop_content ly_pop_msg ly_txt">
          <div class="ly_pop_head">
            <a class="btn_ly_close svg_close" @click="toggleCancelOrderModal"
              ><span>{{ $t('library.deletemodal.close') }}</span></a
            >
          </div>
          <div class="ly_inner cancel_modal">
            <p class="tac">
              {{
                $t('views.member.orders.1661', { '1': selectedOrder.orderCd })
              }}
            </p>
            <!-- <p class="tac">{{ $t('views.member.orders.9615') }}</p> -->
            <!-- 내일없앨거 20210223 -->

            <div class="btn_wrap two_btn">
              <button
                class="ModalBtn box_btn dull"
                @click="toggleCancelOrderModal"
              >
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </button>
              <button class="ModalBtn box_btn" @click="cancelOrder">
                <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </transition>

    <!-- Message MODAL -->
    <transition v-on-clickaway="toggleMessageModal" name="modal-fade">
      <Modal v-if="showMessageModal" @close="toggleMessageModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleMessageModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ message }}
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import AccountHead from '@/components/member/AccountHead.vue'
import responsiveMixin from '@/mixins/responsive'
import { mapGetters } from 'vuex'
import { ACCOUNT_ORDER_GET_LIST, ACCOUNT_ORDER_CANCEL } from '@/store/types'
import EmptyData from '../../components/common/EmptyData.vue'

export default {
  name: 'Orders',
  components: { AccountHead, EmptyData },
  mixins: [responsiveMixin],
  data() {
    return {
      showCancelOrderModal: false,
      showMessageModal: false,
      currentPage: 1,
      ordersPerPage: 10,
      selectedOrder: null,
      message: '주문 취소가 정상적으로 처리 되었습니다',
      window: {
        width: 0
      }
    }
  },
  computed: {
    ...mapGetters([
      'getAccountOrders',
      'isAccountOrderLoading',
      'getAccountOrderTotalCount',
      'getCurrency'
    ])
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      await vm.$store.dispatch(ACCOUNT_ORDER_GET_LIST, {})
    })
  },
  methods: {
    toggleCancelOrderModal(order) {
      this.showCancelOrderModal = !this.showCancelOrderModal
      this.selectedOrder = order
    },
    toggleMessageModal(message) {
      this.showMessageModal = !this.showMessageModal
      if (this.showMessageModal && message) {
        this.message = message
      }
    },
    async cancelOrder() {
      const id = this.selectedOrder.orderCd
      try {
        await this.$store.dispatch(ACCOUNT_ORDER_CANCEL, id)
        this.toggleCancelOrderModal()
        this.$router.push({ name: 'returns' })
      } catch (err) {
        this.toggleCancelOrderModal()
        this.toggleMessageModal(
          `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
        )
      }
    },
    paginate(page) {
      this.currentPage = page
      this.loadOrders()
    },
    loadOrders() {
      const { currentPage, ordersPerPage } = this
      this.$store.dispatch(ACCOUNT_ORDER_GET_LIST, {
        page: currentPage,
        countPerPage: ordersPerPage
      })
    }
  }
}
</script>
<style src="@/assets/css/page_member.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
// Fix Modal buttons
.mypage_detail .order_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 36px 25px 40px;
  &::after {
    content: none;
  }
  a {
    float: none;
  }
}
.member_st .gap {
  float: none;
}
.ModalBtn {
  margin-left: 6px !important;
  margin-right: 6px !important;
  padding: 20px 25px;
  .an_t {
    font-size: 16px;
    line-height: 1px;
  }
}
.btn_wrap.two_btn {
  display: flex;
  .box_btn {
    height: 56px;
    .an_t {
      font-size: 18px;
      line-height: 56px;
    }
  }
}
.price {
  margin-left: 8px;
  font-weight: bold;
}
.none {
  pointer-events: none;
}
.cancel_button {
  display: block;
  width: 50%;
  margin: auto;
  min-width: 80px;
}
.list_price {
  margin-left: 7px;
  color: #778899;
}
.percent {
  color: #778899;
  .arrow {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m8.672 4.964v1.494l-3.654 2.52-3.69-2.52v-1.494l2.988 1.926v-5.868h1.386v5.868z' fill='%23f00'/%3E%3C/svg%3E%0A");
    background-position: center center;
    background-repeat: no-repeat;
  }
}
.cell {
  .cancel_button.none {
    @at-root .cell:has(.cancel_button.none) {
      display: none;
    }
  }
}
.order_book .info_wrap .meta_title {
  display: block;
  height: auto;
}
.return_button {
  display: block;
  width: 50%;
  margin: auto;
}
.ly_inner.cancel_modal {
  padding-left: 45px;
  padding-right: 45px;
}

@media (min-width: 768px) {
  .mypage_detail .order_book > li {
    display: flex;
    justify-content: space-between;
  }
  .mypage_detail .order_book .btn_wrap {
    display: block;
    width: auto;
  }
  .mypage_detail .order_book > li::after {
    content: none;
  }
  .mypage_detail .order_book .btn_wrap > div + div {
    width: 192px;
  }
}
@media (max-width: 768px) {
  .mypage_detail .order_title a {
    margin-top: 0;
  }
  .mypage_detail .order_title {
    padding: 25px 20px 25px 20px;
  }
}
@media (max-width: 610px) {
  .mypage_detail .order_title dl + dl {
    margin-left: 0;
  }
}
@media (max-width: 480px) {
  .member_st .box_btn .an_t {
    font-size: 12px;
  }
  .member_st .box_btn {
    padding: 0px 10px;
  }
}
</style>
